import { Typography, Form, Input, Button } from "antd";
import { useSignUpWithEmail } from "api/register/useSignUpWithEmail";
import { useRegisterEnumeratorContext } from "context/RegisterEnumeratorContext";
import { RoleTypes } from "enum/role-type-enum";
import React, { useState } from "react";

const { Title, Text } = Typography;

type ConfigurePasswordProps = {
  email: string;
  // role: string | null;
  companyName: string;
};


const ConfigurePassword: React.FC<ConfigurePasswordProps> = ({ email, companyName }) => {
  const [form] = Form.useForm();
  const registerEnumeratorMutation = useSignUpWithEmail();
  const { setRegistrationSteps, registrationSteps } = useRegisterEnumeratorContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    const payload = {
      emailOrPhone: email,
      role: RoleTypes.ENUMERATOR,
      password: values.password,
      companyName: companyName,
    };
    setIsLoading(true);
    registerEnumeratorMutation.mutate(payload, {

      onSuccess: () => {
        setRegistrationSteps({
          ...registrationSteps,
          isPassword: false,
          isVerified: true,
        });
        setIsLoading(false);
      },
    });
  };
  return (
    <>
      <Title level={2}>Create password</Title>
      <div className="mt-12">
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="password"
            label="Password"
            rules={[
            ]}
          >
            <Input type="password" placeholder="Enter your password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="oldPassword"

            //add this inside rule if not want mock bypass
            // 



            rules={[
              { required: true, message: "Please confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Passwords do not match!");
                },
              }),
            ]}
          >
            <Input type="password" placeholder="Enter your password" />
          </Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            className="h-12 px-8  border-2 border-border text-base  flex justify-center items-center gap-2 bg-primary text-white border-none w-full mt-12"
            loading={isLoading}
          >
            Create account
          </Button>
        </Form>
      </div>

      <div className="mt-8">
        <Text className="text-base">
          Signing up as <Text strong>{email}</Text> (not you ?)
        </Text>
      </div>
      <div className="mt-8">
        <Title level={4}>Password requirements:</Title>
        <ul>
          <li className="text-base">Minimum 8 character long - the more, the better</li>
          <li className="text-base mt-3">At least one lowercase & one uppercase character</li>
          <li className="text-base mt-3">At least one number, symbol or whitespace character</li>
        </ul>
      </div>
      <div className="mt-8">
        <Text className="text-base text-sm">
          By creating or signing in to your account, you agree to Hire Enumerator's Terms
          and Privacy policies You may receive marketing messages, and can opt out anytime by using the unsubscribe link in our messages.
        </Text >
      </div>
      <div className="mt-8">
        <Button
          type="default"
          onClick={() => {
            setRegistrationSteps({
              ...registrationSteps,
              isPassword: false,
              isEmail: true 
            });
           }}
          className="h-12 px-8 border-2 border-border text-base flex justify-center items-center gap-2 w-full"
        >
          Back
        </Button>
      </div>
    </>
  );
};

export default ConfigurePassword;
